/* #ifndefall OPEN-SOURCE
 * 物流管理
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
export default {
  path: 'logistics',
  name: 'BusinessLogistics',
  component: EmptyRouterAlive,
  meta: {
    title: '物流管理',
  },
  children: [
    /**  物流商管理 */
    {
      path: 'company',
      name: 'BusinessLogisticsCompany',
      redirect: 'company/list',
      component: EmptyRouter,
      meta: {
        title: '物流商管理',
      },
      children: [
        // Logistics Company 物流商列表
        {
          path: 'list',
          name: 'BusinessLogisticsCompanyListIndex',
          component: () => import('@/views/center-business/logistics/company/list'),
          meta: {
            title: '物流商列表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessLogisticsCompanyList_Add',
          meta: { title: '新增物流商', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyList_Edit',
          meta: { title: '编辑物流商' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyList_Status',
          meta: { title: '启用/禁用物流商' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyList_Delete',
          meta: { title: '删除物流商' },
          hidden: true,
        },
        /** 按钮权限end */
        // Logistics Business 物流业务管理
        {
          path: 'business',
          name: 'BusinessLogisticsCompanyBusinessIndex',
          component: () => import('@/views/center-business/logistics/company/business'),
          meta: {
            title: '物流业务管理',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessLogisticsCompanyBusiness_Add',
          meta: { title: '新增物流业务', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyBusiness_Edit',
          meta: { title: '编辑物流业务' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyBusiness_Status',
          meta: { title: '启用/禁用物流业务' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyBusiness_Delete',
          meta: { title: '删除物流业务' },
          hidden: true,
        },

        // Logistics Business 物流业务管理
        {
          path: 'postcode',
          name: 'BusinessLogisticsCompanyPostCodeIndex',
          component: () => import('@/views/center-business/logistics/company/postcode'),
          meta: {
            title: '邮编管理',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessLogisticsCompanyPostCode_Add',
          meta: { title: '新增邮编', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyPostCode_Edit',
          meta: { title: '编辑邮编' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessLogisticsCompanyPostCode_Delete',
          meta: { title: '删除邮编' },
          hidden: true,
        },
      ],
    },
    /**  物流商管理 -- CSGUser */
    {
      path: 'company/csgUser',
      name: 'BusinessLogisticsCompanyCSGUser',
      redirect: 'company/csgUser/list',
      component: EmptyRouter,
      meta: {
        title: '物流商管理',
      },
      children: [
        // Logistics Company 物流商列表  CSGUser 端
        {
          path: 'list',
          name: 'BusinessLogisticsCompanyListIndexCSGUser',
          component: () => import('@/views/center-business/logistics/company/csgUser/list'),
          meta: {
            title: '物流商列表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        // Logistics Business 物流业务管理  CSGUser 端
        {
          path: 'business',
          name: 'BusinessLogisticsCompanyBusinessIndexCSGUser',
          component: () => import('@/views/center-business/logistics/company/csgUser/business'),
          meta: {
            title: '物流业务管理',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },

      ],
    },
    /**  物流商管理 -- CSGAdmin */
    {
      path: 'company/csgAdmin',
      name: 'BusinessLogisticsCompanyCSGAdmin',
      redirect: 'company/csgAdmin/list',
      component: EmptyRouter,
      meta: {
        title: '物流商管理',
      },
      children: [
        // Logistics Company 物流商列表  CSGAdmin 端
        {
          path: 'list',
          name: 'BusinessLogisticsCompanyListIndexCSGAdmin',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/list'),
          meta: {
            title: '物流商列表',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        // Logistics Business 物流业务管理  CSGAdmin 端
        {
          path: 'business',
          name: 'BusinessLogisticsCompanyBusinessIndexCSGAdmin',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/business'),
          meta: {
            title: '物流业务管理',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        // 派送渠道设置  CSGAdmin 端
        {
          path: 'setting',
          name: 'BusinessLogisticsCompanyBusinessSetting',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/setting'),
          meta: {
            title: '派送渠道设置',
            isCache: true
          },
          hidden: true,
        },
        // Logistics Postcode 邮编管理  CSGAdmin 端
        {
          path: 'postcode',
          name: 'BusinessLogisticsCompanyPostCodeIndexCSGAdmin',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/postcode'),
          meta: {
            title: '邮编管理',
            isCache: true
          },
          permissionType: 'tab',
          hidden: true,
        },
        // Logistics Management 客户物流管理  CSGAdmin 端
        // {
        //   path: 'management',
        //   name: 'BusinessLogisticsCompanyManagementIndexCSGAdmin',
        //   component: () => import('@/views/center-business/logistics/company/csgAdmin/management'),
        //   meta: {
        //     title: '客户物流管理',
        //     isCache: true
        //   },
        //   permissionType: 'tab',
        //   hidden: true,
        // },
      ],
    },
    {
      path: 'import',
      name: 'BusinessLogisticsImport',
      redirect: 'company/import',
      component: EmptyRouter,
      meta: {
        title: '物流信息导入',
      },
      children: [
        {
          path: 'import',
          name: 'BusinessLogisticsImport',
          component: () => import('@/views/center-business/logistics/company/import'),
          meta: {
            title: '物流信息导入',
            isCache: true
          },
        },
      ],
    },
    /** 物流费率 */
    {
      path: 'rate',
      name: 'BusinessLogisticsRate',
      component: EmptyRouter,
      redirect: 'rate/index',
      meta: {
        title: '物流费率',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessLogisticsRateIndex',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/rate'),
          meta: {
            title: '物流费率',
            breadcrumb: false
          },
        },
      ],
    },
    /** 物流费率---新 */
    {
      path: 'rateNew',
      name: 'BusinessLogisticsNewRate',
      component: EmptyRouter,
      redirect: 'rateNew/index',
      meta: {
        title: '物流费率',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessLogisticsNewRateIndex',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/rateNew'),
          meta: {
            title: '物流费率',
            breadcrumb: false
          },
        },
      ],
    },
    /** 区域分组 */
    {
      path: 'zone',
      name: 'BusinessLogisticsZone',
      component: EmptyRouter,
      redirect: 'zone/index',
      meta: {
        title: '区域分组',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessLogisticsZoneIndex',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/zone'),
          meta: {
            title: '区域分组',
            breadcrumb: false
          },
        },
        {
          path: 'detail',
          name: 'BusinessLogisticsZoneDetail',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/zone/components/zoneDetail'),
          meta: {
            title: '区域明细',
            breadcrumb: false
          },
        },
        {
          path: 'importFile',
          name: 'BusinessLogisticsZoneImportFile',
          component: () => import('@/views/center-business/logistics/company/csgAdmin/zone/components/importFile'),
          meta: {
            title: '区域数据导入',
            breadcrumb: false
          },
        },
      ],
    },
    /** 物流产品 */
    {
      path: 'logiGoods',
      name: 'BusinessLogisticsProduct',
      component: EmptyRouter,
      redirect: 'logiGoods/index',
      meta: {
        title: '物流产品',
      },
      children: [
        {
          path: 'index',
          name: 'BusinessLogisticsProduct',
          component: () => import('@/views/center-business/logistics/logiGoods'),
          meta: {
            title: '物流产品',
            breadcrumb: false
          },
        },
        {
          path: 'setting',
          name: 'BusinessLogisticsProductSetting',
          component: () => import('@/views/center-business/logistics/logiGoods/setting'),
          meta: {
            title: '产品设置',
            breadcrumb: false
          },
        },
      ],
    },
    /* ******************************  暂时不显示  *******************************/
    /**  物流单管理 */
    // {
    //   path: 'order',
    //   name: 'BusinessLogisticsOrder',
    //   component: EmptyRouter,
    //   redirect: 'order/sale',
    //   meta: {
    //     title: '物流单管理',
    //   },
    //   children: [
    //     // 物流单管理 - 销售单-列表
    //     {
    //       path: 'sale',
    //       name: 'BusinessLogisticsOrderSale',
    //       component: () => import('@/views/center-business/logistics/order/sale'),
    //       meta: {
    //         title: '销售单物流列表',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //     // 物流单管理 - 销售单-详情
    //     {
    //       path: 'sale/view',
    //       name: 'BusinessLogisticsOrderSaleView',
    //       component: () => import('@/views/center-business/logistics/order/sale/view'),
    //       meta: {
    //         title: '销售单物流详情',
    //       },
    //       hidden: true,
    //     },
    //     // 物流单管理 -售后单 列表
    //     {
    //       path: 'after',
    //       name: 'BusinessLogisticsOrderAfter',
    //       component: () => import('@/views/center-business/logistics/order/after'),
    //       meta: {
    //         title: '售后单物流列表',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //     // 物流单管理 - 售后单-详情
    //     {
    //       path: 'after/view',
    //       name: 'BusinessLogisticsOrderAfterView',
    //       component: () => import('@/views/center-business/logistics/order/after/view'),
    //       meta: {
    //         title: '售后单物流详情',
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },
    /** ************************* */
    /** 物流异常管理 */
    /* ******************************  暂时不显示  *******************************/
    // {
    //   path: 'abnormal',
    //   name: 'BusinessLogisticsAbnormal',
    //   component: EmptyRouter,
    //   redirect: 'abnormal/dataAbort',
    //   meta: {
    //     title: '物流异常管理',
    //   },
    //   children: [
    //     {
    //       path: 'delivery',
    //       name: 'BusinessLogisticsAbnormalDelivery',
    //       component: () => import('@/views/center-business/logistics/abnormal/delivery'),
    //       meta: {
    //         title: '派送异常',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //     {
    //       path: 'dataAbort',
    //       name: 'BusinessLogisticsAbnormalDataAbort',
    //       component: () => import('@/views/center-business/logistics/abnormal/dataAbort'),
    //       meta: {
    //         title: '物流数据异常',
    //       },
    //       permissionType: 'tab',
    //       hidden: true,
    //     },
    //   ],
    // },
    /** ************************* */
    /* ******************************  暂时不显示  *******************************/
    /** 破损理赔管理 */
    // {
    //   path: 'claim',
    //   name: 'BusinessLogisticsClaim',
    //   component: EmptyRouter,
    //   redirect: 'claim/index',
    //   meta: {
    //     title: '破损理赔管理',
    //   },
    //   children: [
    //     {
    //       path: 'index',
    //       name: 'BusinessLogisticsClaimIndex',
    //       component: () => import('@/views/center-business/logistics/claim'),
    //       meta: {
    //         title: '破损理赔管理',
    //       },
    //     },
    //     {
    //       path: 'add',
    //       name: 'BusinessLogisticsClaimAdd',
    //       component: () => import('@/views/center-business/logistics/claim/add'),
    //       meta: {
    //         title: '创建理赔单',
    //       },
    //       hidden: true,
    //     },
    //     {
    //       path: 'view',
    //       name: 'BusinessLogisticsClaimView',
    //       component: () => import('@/views/center-business/logistics/claim/view'),
    //       meta: {
    //         title: '破损理赔详情',
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },
  ],
};
